(() => {
  'use strict';
  if (customElements.get('product-form') || window.__abmiumProductFormLoading) return;

  const current = document.currentScript;
  const source = current?.src || '';
  let observer = null;

  const load = () => {
    if (customElements.get('product-form') || window.__abmiumProductFormLoading) return;
    window.__abmiumProductFormLoading = true;
    const script = document.createElement('script');
    try {
      script.src = new URL('product-form-runtime.js', source || window.location.href).toString();
    } catch (_) {
      window.__abmiumProductFormLoading = false;
      return;
    }
    script.async = true;
    script.fetchPriority = 'low';
    script.onload = () => observer?.disconnect();
    script.onerror = () => { window.__abmiumProductFormLoading = false; };
    document.head.appendChild(script);
  };

  if (document.querySelector('product-form')) {
    load();
    return;
  }

  if (document.querySelector('.abm-pdp, .abm-catalogue')) return;

  observer = new MutationObserver((records) => {
    for (const record of records) {
      for (const node of record.addedNodes) {
        if (!(node instanceof Element)) continue;
        if (node.matches?.('product-form') || node.querySelector?.('product-form')) {
          load();
          return;
        }
      }
    }
  });
  observer.observe(document.documentElement, { childList: true, subtree: true });
  window.setTimeout(() => observer?.disconnect(), 15000);
})();
